import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ButtonGroup,
  Input,
  Container,
  Label,
  Row,
  Col,
  CustomInput,
} from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import * as timesheetHelper from '../helpers/timesheet'
import SearchIcon from "../../../static/images/search_icon.svg"

export const AddProjectForm = (props) => {
  const { clickRadioAddProject, handleCheckboxAddProject,
    clickButtonAddProject, handleChangeSearch, toggle } = props
  const { selectedRadioAddProject, open, selectedProject, myProjects, searchAddProject } = props
  const filteredProjects = timesheetHelper.filterProjects(
    selectedRadioAddProject, myProjects, searchAddProject
  )
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal isOpen={ open } toggle={ () => toggle() }>
        <ModalHeader toggle={ () => toggle() }>
          <HeadLabel>{ `Add Project` }</HeadLabel>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <TypeButtonGroup>
                <TypeButton
                  color="primary"
                  style={ {
                    backgroundColor: (selectedRadioAddProject === 1) ? '#AD2624' : '#FFFFFF',
                    color: (selectedRadioAddProject === 1) ? '#FFFFFF' : '#D44B49',
                    border: '1px solid #AD2624',
                  } }
                  onClick={ () => clickRadioAddProject(1) }
                  active={ selectedRadioAddProject === 1 }
                >All
                </TypeButton>
                <TypeButton
                  color="primary"
                  style={ {
                    backgroundColor: (selectedRadioAddProject === 2) ? '#AD2624' : '#FFFFFF',
                    color: (selectedRadioAddProject === 2) ? '#FFFFFF' : '#D44B49',
                    border: '1px solid #AD2624',
                  } }
                  onClick={ () => clickRadioAddProject(2) }
                  active={ selectedRadioAddProject === 2 }
                >Chargeable
                </TypeButton>
                <TypeButton
                  color="primary"
                  style={ {
                    backgroundColor: (selectedRadioAddProject === 3) ? '#AD2624' : '#FFFFFF',
                    color: (selectedRadioAddProject === 3) ? '#FFFFFF' : '#D44B49',
                    border: '1px solid #AD2624',
                  } }
                  onClick={ () => clickRadioAddProject(3) }
                  active={ selectedRadioAddProject === 3 }
                >Non-Charge
                </TypeButton>
              </TypeButtonGroup>
              <SearchField
                placeholder='Search by project code or name'
                onChange={ (e) => handleChangeSearch(e) }
              />
              <CheckboxGroup>
                <Row>
                  <Col>
                    {
                      filteredProjects.map(project => {
                        return (
                          <CustomInput
                            key={ get(project, '_id', '') }
                            id={ get(project, '_id', '') }
                            name='checkboxAddProject'
                            type='checkbox'
                            label={ `${get(project, 'project_code', '')} - ${get(project, 'name', '')}` }
                            onChange={ handleCheckboxAddProject }
                            checked={ selectedProject.includes(get(project, '_id', '')) }
                            value={ searchAddProject }
                          />
                        )
                      })
                    }
                  </Col>
                </Row>
              </CheckboxGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <FooterButton
            bgColor='#AD2624'
            onClick={ () => clickButtonAddProject('add') }
          >Add
          </FooterButton>
          <FooterButton
            bgColor='white'
            textColor='black'
            onClick={ () => clickButtonAddProject('cancel') }
          >Cancel
          </FooterButton>
        </ModalFooter>
      </Modal>
    </div>
  )
}

AddProjectForm.propTypes = {
  open: PropTypes.bool,
  myProjects: PropTypes.array,
  clickRadioAddProject: PropTypes.func,
  handleCheckboxAddProject: PropTypes.func,
  clickButtonAddProject: PropTypes.func,
  handleChangeSearch: PropTypes.func,
  toggle: PropTypes.func,
  selectedRadioAddProject: PropTypes.number,
  searchAddProject: PropTypes.string,
  selectedProject: PropTypes.array,
}
AddProjectForm.defaultProps = {
  open: false,
  myProjects: [],
  selectedProject: [],
  selectedRadioAddProject: 1,
  searchAddProject: '',
  clickRadioAddProject: () => {},
  handleCheckboxAddProject: () => {},
  clickButtonAddProject: () => {},
  handleChangeSearch: () => {},
  toggle: () => {},
}

const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  color: #AD2624;
`
const TypeButtonGroup = styled(ButtonGroup)`
  display: flex;
  font-family: 'Gotham' !important;
`
const TypeButton = styled(Button)`
  width: 100%;
`
const FooterButton = styled(Button)`
  margin-right: 10px;
  background-color: ${props => props.bgColor};
  color: ${props => props.textColor};
  font-family: 'Gotham' !important;
`
const SearchField = styled(Input)`
  width: 100%;
  padding-left: 35px;
  margin-top: 20px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: 'Gotham' !important;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const CheckboxGroup = styled(Container)`
  height: 300px;
  overflow-y: scroll;
  margin-top: 20px;
  padding: 20px;
  border: 1px solid lightgray;
  border-radius: 5px;
  font-family: 'Gotham' !important;
  font-size: 15px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/form/add-project.js